// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/slickgrid/dist/styles/css/slick.columnpicker.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js!../node_modules/slickgrid/dist/styles/css/slick-alpine-theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
<link rel="stylesheet" href="../dist/styles/css/slick.gridmenu.css" type="text/css"/>
<link rel="stylesheet" href="../dist/styles/css/slick.pager.css" type="text/css"/>
<link rel="stylesheet" href="../dist/styles/css/slick-icons.css" type="text/css"/>
<link rel="stylesheet" href="../dist/styles/css/example-demo.css" type="text/css"/>
<link rel="stylesheet" href="../dist/styles/css/slick-alpine-theme.css" type="text/css"/>
*/

:host {
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  /*align-items: flex-start;*/
  flex-grow: 1;
  /*box-shadow: 0px 2px 8px 0px rgba(0, 93, 152, 0.15);*/
  border-radius: var(--Radius-radius-l, 16px);
  padding-top: 12px;
}

#table-target {
  width: 100%;
  height: 100%;
  min-height: 300px;
  border-radius: var(--Radius-radius-l, 16px);
}

.hs-preheader-group {
  position: absolute;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: clip;
  white-space: normal;
  line-height: normal;
  text-align: center;
  font-size: 12px;
  font-weight: 700;
  color: rgb(0, 50, 82);
  border-right: 1px solid #e5edf2;
  background: #FFFF;
}

.hs-preheader-group:last-child {
  border-right: none;
}


.icon-link {
  cursor: pointer;
}
.icon-link > img {
  vertical-align: middle;
  height: 18px;
  width: 18px;
}
.icon-link > span {
  vertical-align: middle;
}

.slick-container {
  border: none;
  overflow-x: auto;
  overflow-y: hidden;

  .slick-header {
    background-color: none;
    border-bottom: none;

    .slick-header-columns {
      .slick-header-column {
        padding: .5rem .5rem;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
        align-items: center;
        justify-content: space-between;
        color: rgb(0, 50, 82) !important;
        background: #FFFF !important;

        .slick-sort-indicator {
          margin: 0px !important;
          color: #003252 !important;
        }
      }

      .slick-state-hover {
        background-color: #FFFF;
      }
    }
  }

  .slick-pane {
    .slick-state-default {
      .slick-top-panel {
        height: auto;
      }
    }
    .slick-viewport {
      overflow-x: auto !important;
      overflow-y: auto !important;

      .grid-canvas {
        .ui-widget-content.slick-row {
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        .even {
          background: #F5F5F5;
        }

        .odd {
          background: #FFFF;
        }

        .slick-cell {
          border: none;
          font-size: 12px;
          font-weight: 400;
          color: #525252;
          height: auto;
        }

        .slick-row.hs-totals-row {
          background: #EAF4FF !important;
          border-top: 1px solid #2E72B7;
          border-bottom: 1px solid #2E72B7;
          font-weight: 700;
        }
        .slick-row.hs-totals-row .slick-cell {
          background: transparent;
          font-weight: 700;
          color: #113E57;
        }
      }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/table.css"],"names":[],"mappings":"AAGA;;;;;;CAMC;;AAED;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,YAAY;EACZ,sDAAsD;EACtD,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;;AAGA;EACE,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;;EAElB;IACE,sBAAsB;IACtB,mBAAmB;;IAEnB;MACE;QACE,oBAAoB;QACpB,eAAe;QACf,gBAAgB;QAChB,eAAe;QACf,mBAAmB;QACnB,8BAA8B;QAC9B,gCAAgC;QAChC,4BAA4B;;QAE5B;UACE,sBAAsB;UACtB,yBAAyB;QAC3B;MACF;;MAEA;QACE,uBAAuB;MACzB;IACF;EACF;;EAEA;IACE;MACE;QACE,YAAY;MACd;IACF;IACA;MACE,2BAA2B;MAC3B,2BAA2B;;MAE3B;QACE;UACE,aAAa;UACb,mBAAmB;UACnB,2BAA2B;QAC7B;;QAEA;UACE,mBAAmB;QACrB;;QAEA;UACE,iBAAiB;QACnB;;QAEA;UACE,YAAY;UACZ,eAAe;UACf,gBAAgB;UAChB,cAAc;UACd,YAAY;QACd;;QAEA;UACE,8BAA8B;UAC9B,6BAA6B;UAC7B,gCAAgC;UAChC,gBAAgB;QAClB;QACA;UACE,uBAAuB;UACvB,gBAAgB;UAChB,cAAc;QAChB;MACF;IACF;EACF;AACF","sourcesContent":["@import url(\"~slickgrid/dist/styles/css/slick.columnpicker.css\");\n@import url(\"~slickgrid/dist/styles/css/slick-alpine-theme.css\");\n\n/*\n<link rel=\"stylesheet\" href=\"../dist/styles/css/slick.gridmenu.css\" type=\"text/css\"/>\n<link rel=\"stylesheet\" href=\"../dist/styles/css/slick.pager.css\" type=\"text/css\"/>\n<link rel=\"stylesheet\" href=\"../dist/styles/css/slick-icons.css\" type=\"text/css\"/>\n<link rel=\"stylesheet\" href=\"../dist/styles/css/example-demo.css\" type=\"text/css\"/>\n<link rel=\"stylesheet\" href=\"../dist/styles/css/slick-alpine-theme.css\" type=\"text/css\"/>\n*/\n\n:host {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  flex-direction: column;\n  justify-content: center;\n  /*align-items: flex-start;*/\n  flex-grow: 1;\n  /*box-shadow: 0px 2px 8px 0px rgba(0, 93, 152, 0.15);*/\n  border-radius: var(--Radius-radius-l, 16px);\n  padding-top: 12px;\n}\n\n#table-target {\n  width: 100%;\n  height: 100%;\n  min-height: 300px;\n  border-radius: var(--Radius-radius-l, 16px);\n}\n\n.hs-preheader-group {\n  position: absolute;\n  top: 0;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 10px;\n  box-sizing: border-box;\n  overflow: hidden;\n  text-overflow: clip;\n  white-space: normal;\n  line-height: normal;\n  text-align: center;\n  font-size: 12px;\n  font-weight: 700;\n  color: rgb(0, 50, 82);\n  border-right: 1px solid #e5edf2;\n  background: #FFFF;\n}\n\n.hs-preheader-group:last-child {\n  border-right: none;\n}\n\n\n.icon-link {\n  cursor: pointer;\n}\n.icon-link > img {\n  vertical-align: middle;\n  height: 18px;\n  width: 18px;\n}\n.icon-link > span {\n  vertical-align: middle;\n}\n\n.slick-container {\n  border: none;\n  overflow-x: auto;\n  overflow-y: hidden;\n\n  .slick-header {\n    background-color: none;\n    border-bottom: none;\n\n    .slick-header-columns {\n      .slick-header-column {\n        padding: .5rem .5rem;\n        font-size: 12px;\n        font-weight: 700;\n        cursor: pointer;\n        align-items: center;\n        justify-content: space-between;\n        color: rgb(0, 50, 82) !important;\n        background: #FFFF !important;\n\n        .slick-sort-indicator {\n          margin: 0px !important;\n          color: #003252 !important;\n        }\n      }\n\n      .slick-state-hover {\n        background-color: #FFFF;\n      }\n    }\n  }\n\n  .slick-pane {\n    .slick-state-default {\n      .slick-top-panel {\n        height: auto;\n      }\n    }\n    .slick-viewport {\n      overflow-x: auto !important;\n      overflow-y: auto !important;\n\n      .grid-canvas {\n        .ui-widget-content.slick-row {\n          display: flex;\n          align-items: center;\n          justify-content: flex-start;\n        }\n\n        .even {\n          background: #F5F5F5;\n        }\n\n        .odd {\n          background: #FFFF;\n        }\n\n        .slick-cell {\n          border: none;\n          font-size: 12px;\n          font-weight: 400;\n          color: #525252;\n          height: auto;\n        }\n\n        .slick-row.hs-totals-row {\n          background: #EAF4FF !important;\n          border-top: 1px solid #2E72B7;\n          border-bottom: 1px solid #2E72B7;\n          font-weight: 700;\n        }\n        .slick-row.hs-totals-row .slick-cell {\n          background: transparent;\n          font-weight: 700;\n          color: #113E57;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
